import EndpointService from '../Service/EndpointService';
import moment from 'moment';
import Immutable, { fromJS } from 'immutable';


export function getClientDocuments(clientid) {

    return dispatch => {

        return new Promise((resolve, reject) => {
            return EndpointService.get(`/clientportal/api/client/documents`).then((response) => {
                resolve(fromJS(response.data));
            }).catch(reject);
        })

        
    }

}